module.exports = __webpack_public_path__ + "img/MYS.8358896e.svg";